type Play = {
  fields: {
    name: string
    selected: number[]
  }[]
  isComplete: boolean
  isValid: boolean
}

type QuickPickConfig = {
  max?: number
  min?: number
  selectableMax: number
  selectableNumbers?: number[]
}

export const quickPickPlay = (
  { fields, isComplete, isValid }: Play,
  { max, min, selectableMax, selectableNumbers }: QuickPickConfig,
  fieldIndex: number,
  clearIfComplete = true,
) => {
  const numbers = new Set(fields[fieldIndex]?.selected)

  if (clearIfComplete) {
    const areAllFieldsComplete = fields.every(({ selected }) => selected.length === selectableMax)
    if (isComplete || (!isValid && areAllFieldsComplete)) numbers.clear()
  }

  return quickPickNumbers({ max, min, selectableMax, selectableNumbers }, numbers)
}

export const quickPickNumbers = (
  { max, min, selectableMax, selectableNumbers }: QuickPickConfig,
  numbers: Set<number> = new Set(),
) => {
  if (selectableNumbers?.length) {
    const available = selectableNumbers.filter((number) => !numbers.has(number))
    while (numbers.size < selectableMax && available.length) {
      const index = getRandomNumber(0, available.length - 1)
      numbers.add(available[index])
      available.splice(index, 1)
    }

    return [...numbers].sort((a, b) => selectableNumbers.indexOf(a) - selectableNumbers.indexOf(b))
  }

  if (typeof min !== 'number' || typeof max !== 'number') return [...numbers].sort((a, b) => a - b)

  while (numbers.size < selectableMax) {
    numbers.add(getRandomNumber(min, max))
  }

  return [...numbers].sort((a, b) => a - b)
}
